<template lang="pug">
  div.print-absolute.map-container.geo.map-objects
    .no-print.toolbar(v-if="hasSearchMapFields || hasMapComplaint || (!isGuest && hasLinkToCommonMap) || !isSimilarTitle")
      .mobile-title
        span.mobile-title__number.semibold 01
        span Территориальная схема
      div.line.toolbar__line
        h1.title.toolbar__title {{$translate('Карта объектов')}}
        map-complaint(v-if='hasMapComplaint' :map="map")
        button.reset-btn.button.button_link.button_no-border.button_transparent(
          v-if='!isGuest && hasLinkToCommonMap'
          data-to="/#/terSchema"
          @click="copyUrl"
        ) {{ $translate('Ссылка на общедоступную карту') }}
    date-slider(
      :style="yearSelectorStyles"
      :mapType='selectedMappingObject'
      @map-update='updateMapByYear'
      :route='$route'
    )
    map-mapping-legend(
      :mappingCurrentLegend="mappingCurrentLegend"
      :legendItems="legendItems"
    )
    map-layer-legend(
      :items="layerLegendItems"
      :layerGroups="layerGroups"
    )
    div.new-map
      #map.map.absolute(ref="map" v-once :class="isSimilarTitle ? 'map_from-top' : ''")
      transition(name="fade")
        .no-print.legend.legend--objects.cuscroll(:class="[showMapLegend ? 'opened' : 'closed', isSimilarTitle ? 'legend_from-top' : '' ]")
          div(v-if="layersLoading").hover-on-loading
          e-perfect-scrollbar
            div.legend__head(@click="showMapLegend = !showMapLegend")
              button.reset-btn.legend__close(v-if="showMapLegend")
              button.reset-btn.legend__open(v-else)
              h2.legend__title {{$translate('Слои')}}
            div(
              v-if="userData && userData.isAdmin && hasClusterFilter"
            ).legend__group
              div.legend__type
                label.legend__switch.switch
                  span.semibold.legend__name Кластеризация
                  input.visually-hidden.switch__input(type="checkbox" @change="toggleClusters" v-model="clusterEnabled")
                  span.switch__block
            map-mapping-selector(
              :mappingConfObject="mappingConfObject"
              :selectedMappingObject="selectedMappingObject"
              @change="setSelectedMappingObject"
              @rosreestrChangeView="onRosreestrChangeView"
              @showEquidistant="onShowEquidistant"
              @setEquidistant="updateEquidistantCircle"
              @showEquidistantGeo="setShowEquidistantGeo"
              @equidistantGeo="setEquidistantGeo"
            )
            map-search-fields(v-if="hasSearchMapFields" :map="map" :year="year")
            .legend__group.legend__group_status
              .legend__type
                .semibold.legend__name
                  span {{$translate('Статус')}}
              .legend__small-group
                div
                  el-tooltip(
                    v-for="item in statuses" :key="'status-' + item.id"
                    v-if="item.show"
                    transition="none"
                    effect="light"
                    placement="left"
                    :content="layers.length === 0 ? 'Выберите объекты' : item.text"
                  )
                    div(
                      :class="'type legend__tooltip status-' + item.slug"
                    )
                      .custom-checkbox
                        input.visually-hidden.custom-checkbox__input(
                          :disabled="layers.length === 0"
                          type="checkbox"
                          @change="showStatus"
                          v-model="showedStatus"
                          :value="item.id"
                          :id="'checkbox-' + item.slug"
                        )
                        label.legend__label.custom-checkbox__label(:for="'checkbox-' + item.slug")
                          span.custom-checkbox__block
                          span.legend__marker
                          span.custom-checkbox__text {{$translate(item.name)}}
            div.legend__group(v-for="(item, name) in layersConf" :key="name" :class="'legend__group_' + item.iconType")
              div.legend__type
                .custom-checkbox
                  input.visually-hidden.custom-checkbox__input(type="checkbox" @change="onLayersChange(item, name)" v-model="layers" :value="name"  :id="'checkbox-' + name")
                  label.legend__label.custom-checkbox__label(:for="'checkbox-' + name")
                    span.custom-checkbox__block
                    span.legend__marker
                    span.custom-checkbox__text.semibold {{$translate(item.label)}}
              template(v-if="item.groups" v-for="(groupItem, groupItemName) in item.groups")
                div(v-if="groupItem && groupItem.label !== item.label").legend__small-group
                  .custom-checkbox
                    input.visually-hidden.custom-checkbox__input(
                      type="checkbox"
                      :id="'checkbox-' + groupItemName"
                      :value="groupItemName"
                      v-model="layers"
                      @change="onLayersChange(groupItem, groupItemName, name)"
                    )
                    label.legend__label.custom-checkbox__label(:for="'checkbox-' + groupItemName")
                      span.custom-checkbox__block
                      span.legend-icon(:class="'legend-icon_' + groupItem.iconType")
                      span.custom-checkbox__text {{$translate(groupItem.label)}}
            div.legend__group.legend__group_operator(v-if="hasZoneOperators && apolist.length > 0")
              div.legend__type
                .custom-checkbox
                  input.visually-hidden.custom-checkbox__input(type="checkbox" id="checkbox-zones" @change="onOperatorsChange()" v-model="operatorsCommon" :value="Boolean(operatorsCommon)")
                  label.legend__label.custom-checkbox__label(for="checkbox-zones")
                    span.custom-checkbox__block
                    span.legend__marker
                    span.custom-checkbox__text.semibold Зоны деятельности региональных операторов
              .legend__small-group(v-for="item in apolist" :key="item.id")
                .custom-checkbox
                  input.visually-hidden.custom-checkbox__input(
                    type="checkbox"
                    :value="item.id"
                    :id="'checkbox-zone-' + item.id"
                    @change="updateRegop"
                  )
                  label.legend__label.custom-checkbox__label(:for="'checkbox-zone-' + item.id")
                    span.custom-checkbox__block
                    span.custom-checkbox__text {{item.name}}

            div.legend__group.legend__group_operator(v-if="hasZoneTransportation && apolist.length > 0")
              div.legend__type
                .custom-checkbox
                  input.visually-hidden.custom-checkbox__input(type="checkbox" id="checkbox-regzone" @change="onOperatorsZoneChange()" v-model="operatorsZoneCommon" :value="Boolean(operatorsZoneCommon)")
                  label.legend__label.custom-checkbox__label(for="checkbox-regzone")
                    span.custom-checkbox__block
                    span.legend__marker
                    span.custom-checkbox__text.semibold Зоны транспортирования
              .legend__small-group(v-for="item in regoplist" :key="item.id")
                .custom-checkbox
                  input.visually-hidden.custom-checkbox__input(
                    type="checkbox"
                    :value="item.id"
                    :id="'checkbox-regzone-' + item.id"
                    @change="updateRegopZone"
                  )
                  label.legend__label.custom-checkbox__label(:for="'checkbox-regzone-' + item.id")
                    span.custom-checkbox__block
                    span.custom-checkbox__text(v-html="item.name" )
    router-view
</template>

<script>
import objectsMixin from './mixins/objects-mixin'
import mappingMixin from './mixins/mapping-mixin'
import geoSearchMixin from './mixins/geo-search-mixin'
import hasMixin from '@/mixins/has-mixin'
import MapMappingLegend from './components/map-mapping-legend'
import MapMappingSelector from './components/map-mapping-selector'
import MapLayerLegend from './components/map-layer-legend'
import MapComplaint from './components/map-complaint'
import DateSlider from './components/map-date-slider'
import MapSearchFields from './components/map-search-fields'
import { statuses } from './config/statuses'
import { REGION_CONFIG } from '@/config/regions'
import { atu, tko } from '@/api/api-endpoints'
import year from '@/utils/year'
import * as L from 'leaflet'
import { COLORS } from '@/utils'

export default {
  name: 'objects',
  components: {
    MapMappingSelector,
    MapMappingLegend,
    MapLayerLegend,
    DateSlider,
    MapComplaint,
    MapSearchFields,
  },
  mixins: [objectsMixin, mappingMixin, geoSearchMixin, hasMixin],
  data: () => ({
    operatorsCommon: false,
    operatorsZoneCommon: false,
    year: year.getCurrentYear(),
    statuses,
    operatorLayers: null,
    operatorZoneLayers: null,
    apolist: [],
    regoplist: [],
    selectedOperators: [],
    selectedZoneOperators: [],
    objects: [],
  }),
  computed: {
    isGuest() {
      return this.$store.getters.isGuest
    },
    isSimilarTitle() {
      return this.$route.meta.title === this.$route.meta.parentTitle
    },
  },
  methods: {
    getLayersConf() {
      return REGION_CONFIG.rightMenu
    },
    updateMapByYear(year) {
      this.year = year
      this.yearChanged = true
      if (this.operatorsCommon || this.selectedOperators.length) {
        this.onOperatorsChange(this.selectedOperators)
      }
      //дёрнуть обнову года в url
      this.replaceRoute({ year }, false)
      // дёргаем обнову данных на карте ...
      switch (this.selectedMappingObject) {
        case 'formed':
          this.onMappingCurrentLegend()
          break
        case 'zones':
          break
      }
    },
    async getZone() {
      const operators = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: tko.operatorsZone(),
        })
      ).data.data

      this.regoplist = operators.map((item) => {
        item.checked = false
        return item
      })
    },
    async getApo() {
      const list = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.apoName(),
        })
      ).data.data
      this.apolist = list.map((item) => {
        item.checked = false
        return item
      })
    },
    updateRegopZone(event) {
      let selectedItem_ = this.regoplist.find(
        (item) => item.id === Number(event.target.value)
      )
      selectedItem_.checked = !selectedItem_.checked
      if (selectedItem_.checked) {
        this.selectedZoneOperators.push(selectedItem_.id)
      } else {
        this.selectedZoneOperators = this.selectedZoneOperators.filter((i) => {
          return selectedItem_.id !== i
        })
      }
      this.onOperatorsZoneChange(this.selectedZoneOperators)
    },
    async onOperatorsZoneChange(zone = []) {
      if (this.operatorsZoneCommon) {
        zone = this.regoplist.map(({ id }) => id)
      }
      if (!zone.length) {
        this.operatorZoneLayers.clearLayers()
      } else {
        const zones = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: tko.operatorsGeoZone(zone.join(',')),
          })
        ).data.data
        if (this.operatorZoneLayers) {
          this.operatorZoneLayers.clearLayers()
        } else {
          this.operatorZoneLayers = new L.FeatureGroup()
        }
        if (this.operatorZoneLayers) {
          this.map.addLayer(this.operatorZoneLayers)
          zones.forEach((item) => {
            const geoJson = JSON.parse(item.geojson)
            const getGeoJson = L.geoJson(geoJson, {
              color: item.color || COLORS.blue,
            })
            this.operatorZoneLayers.addLayer(getGeoJson)
          })
        }
      }
    },

    updateRegop(event) {
      const selectedItem = this.apolist.find(
        (item) => item.id === Number(event.target.value)
      )
      selectedItem.checked = !selectedItem.checked
      if (selectedItem.checked) {
        this.selectedOperators.push(selectedItem.id)
      } else {
        const index = this.selectedOperators.findIndex(
          (item) => item === selectedItem.id
        )
        this.selectedOperators.splice(index, 1)
      }
      this.onOperatorsChange(this.selectedOperators)
    },
    async onOperatorsChange(apoIds = []) {
      if (this.operatorLayers) {
        this.operatorLayers.clearLayers()
      } else {
        this.operatorLayers = new L.FeatureGroup()
      }
      const query = {
        year: this.year,
      }
      if (!this.operatorsCommon) {
        if (apoIds.length) {
          query.apo_ids = apoIds.join(',')
        } else {
          delete query.apo_ids
          return false
        }
      }
      const response = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.apoGeoObject({ query }),
          fromCache: false,
        })
      ).data.data
      if (this.operatorLayers) {
        this.map.addLayer(this.operatorLayers)
        response.forEach((item) => {
          const geoJson = JSON.parse(item.geo_json)
          const getGeoJson = L.geoJson(geoJson, {
            color: item.color || COLORS.blue,
          })
          this.operatorLayers.addLayer(getGeoJson)
        })
      }
    },
    async getObjects() {
      this.objects = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.atuObjectUpdateOrCreate(),
          fromCache: false,
          notReactive: false,
        })
      ).data.data
      if (this.hasObjectBorders) {
        this.getBorders()
      }
    },
    getBorders() {
      const mainBorderLayer = L.layerGroup()

      this.objects.forEach((border) => {
        if (border.polygon) {
          let polygon = JSON.parse(JSON.parse(border.polygon))
          polygon = polygon.flat()
          const polygonReversed = polygon.map((item) => {
            return [item[1], item[0]]
          })
          const poly = L.polygon(polygonReversed, {
            color: COLORS.red,
            fillColor: COLORS.red,
            fillOpacity: 0,
            weight: 1,
          })
          mainBorderLayer.addLayer(poly)
        }
      })
      mainBorderLayer.addTo(this.map)
    },
    copyUrl(e) {
      const button = e.target
      const input = document.body.appendChild(document.createElement('input'))
      input.value = window.location.host + button.getAttribute('data-to')
      input.focus()
      input.select()
      document.execCommand('copy')
      input.parentNode.removeChild(input)
      this.$notify.success({
        title: `Ссылка скопирована в буфер`,
      })
    },
  },
  mounted() {
    this.map.on('zoomend', () => {
      if (this.selectedMappingObject == 'formed') {
        this.onMappingCurrentLegend()
      }
    })
    this.map.on('zoomend', () => {
      if (this.selectedMappingObject == 'population') {
        this.onMappingCurrentLegend()
      }
    })
    this.map.on('zoomend', () => {
      if (this.selectedMappingObject == 'recycle') {
        this.onMappingCurrentLegend()
      }
    })
    this.map.on('zoomend', () => {
      if (this.selectedMappingObject == 'tomb') {
        this.onMappingCurrentLegend()
      }
    })
    this.map.on('zoomend', () => {
      if (this.selectedMappingObject == 'regOperatorsZones') {
        this.onMappingCurrentLegend()
      }
    })
    if (REGION_CONFIG.rosreestr_view === 'yandex') {
      this.addYandexTile()
    }
  },
  created() {
    this.getApo()
    this.getZone()
    this.getObjects()
    if (this.hasObjectBorders) {
      this.getBorders()
    }
  },
}
</script>
<style lang="scss"></style>
